/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AtomServiceExportData } from '@/app/editor/iframe/atom/atom-service/export/AtomServiceExportData';
import type { AtomModel, FormControlSetting, Font } from '@/app/editor/iframe/atom/Atom.model';
declare let Liquid: any;

import { Atom } from '@/app/editor/iframe/atom/Atom';
import HELPER from '@/app/utils/HELPER';
import type { TypeExportData } from '@/app/editor/iframe/atom/Atom.model';
import { BaseAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';

/**
 * GpHeroBannerExportService
 */
export class GpHeroBannerExportService extends AtomServiceExportData {
  /**
   * formatDataAtomInExport
   * @override AtomServiceExportData.formatDataAtomInExport
   * @param data data export
   * @returns new data export
   */
  formatDataAtomInExport(data: TypeExportData): TypeExportData {
    data.style = this.supportLazyoad(data.style);
    return data;
  }
  /**
   * supportLazyoad
   * @param style old style
   * @returns style
   */
  supportLazyoad(style: string): string {
    // LAZYLOADING2019
    const lazyload = jQuery('#gfFrame').data('gfframe').getPageLazyload();
    const excludes = ['Popup'];
    /**
     * checkExcludes
     * @param $el atom
     * @returns bool
     */
    const checkExcludes = function ($el: JQuery) {
      let excludeCount = 0;
      for (let i = 0; i < excludes.length; i++) {
        if ($el.parents('[data-label="' + excludes[i] + '"]').length != 0) {
          excludeCount++;
        }
      }
      return excludeCount > 0;
    };
    // Apply lazyload for Hero Banner
    if (lazyload && !checkExcludes(this.atom.$el)) {
      const ptrn = /background-image: *url\([^;}]+\)/gim;
      let match;
      let newStyle = style;
      let src;
      while ((match = ptrn.exec(style)) != null) {
        if (match[0]) {
          const mat = /url\([^;}]+\)/gim.exec(match[0]);
          if (mat && mat[0]) {
            src = mat[0];
            if (
              src.indexOf('ucarecdn.com/') != -1 ||
              src.indexOf('cdn.shopify.com/s/files/') != -1 ||
              src.indexOf('apps.shopifycdn.com/') != -1
            ) {
              src = HELPER.replaceImageSource(src).src;
              newStyle = newStyle.replace(match[0], 'background-image: ' + src);
            }
          }
        }
      }
      style = newStyle;
    }

    return style;
  }
}
/**
 * GpHeroBannerRenderService
 */
export class GpHeroBannerRenderService extends BaseAtomRender {
  /**
   * renderLiquid
   * @override BaseAtomRender.renderLiquid
   * @param templateTmp template string
   * @returns html string
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    const template = HELPER.simpleHTMLEntities(templateTmp);
    // Render liquid
    const tmpl = Liquid.parse(template);
    const html: string = tmpl.render({
      ...this.atom.data.atom.data,
    });
    return html;
  }
}
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:fixedMode',
    name: 'fixedMode',
    targetSelector: '.module',
    property: 'data-fixedmode',
  },
  {
    type: 'css:bgImage',
    name: 'image',
    targetSelector: '',
    property: 'background-image',
  },
  {
    type: 'css:height',
    name: 'height',
    targetSelector: '.module',
    property: 'data-height',
  },
  {
    type: 'html:attr',
    name: 'editLink',
    targetSelector: '.hero-link',
    property: 'href',
  },
];
/**
 * Hero Banner Atom Module
 */
export class GpHeroBanner extends Atom {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: 'Hero Banner',
      slug: 'hero-banner',
      groupName: 'Module',
      settings: this.getSettings(),
      formControlSettings: FormControlSettings,
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }
  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Hero Banner';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'hero-banner';
  }
  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }
  /**
   * @override Atom.initAtomRender
   */
  initAtomRender() {
    this.atomRender = new GpHeroBannerRenderService(this);
  }
  /**
   * @override Atom.initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new GpHeroBannerExportService(this);
  }
}
